import React from 'react';
import {Navigation} from '@homeaway/react-navigation';
import DirectNavigationModel from '../DirectNavigationModel';
import StructureView from '../StructureView/StructureView.react';
import {PropTypes} from 'prop-types';
import LocaleContext from '../../../../../Contexts/Locale/Context';

class StructuresView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            links: nextProps.structures.map((structure) => ({
                labelKey: structure.structureType,
                structure,
            })),
        };
    }

    _onLinkClick = (link, i) => {
        if (this.props.onStructureClick) {
            this.props.onStructureClick(link.structure, i);
        }
    };

    _onGroupClick = (group, structure) => {
        if (this.props.onGroupClick) {
            this.props.onGroupClick(group, structure);
        }
    };

    _onSpaceClick = (space, group, structure) => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(space, group, structure);
        }
    };

    render() {
        return (
            <React.Fragment>
                <LocaleContext.Consumer>
                    {(getTranslation) => (
                        <Navigation
                            noMobileSelect
                            onLinkClick={this._onLinkClick}
                            links={this.state.links.map((link) => {
                                return {
                                    ...link,
                                    label: getTranslation('structureLabels', link.labelKey),
                                };
                            })}
                            activeIndex={this.props.activeIndex}
                        />
                    )}
                </LocaleContext.Consumer>
                <ul className={'Structures'}>
                    {this.props.structures.map((structure, index) => {
                        return (
                            <StructureView
                                structure={structure}
                                key={structure.id}
                                active={index === this.props.activeIndex}
                                onGroupClick={this._onGroupClick}
                                onSpaceClick={this._onSpaceClick}
                            />
                        );
                    })}
                </ul>
            </React.Fragment>
        );
    }
}

StructuresView.propTypes = {
    structures: PropTypes.arrayOf(DirectNavigationModel.structureType).isRequired,
    activeIndex: PropTypes.number.isRequired,
    onStructureClick: PropTypes.func.isRequired,
    onGroupClick: PropTypes.func,
    onSpaceClick: PropTypes.func,
};

export default StructuresView;
